import { FormSection } from '@ksyos/design-system';
import type { AssetCategory } from '@common/enums';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { useProcessActivityEditContext } from '@frontend/utils';
import { ProcessActivityAssetsDropzone } from '../../../processActivityAssets/ProcessActivityAssetsDropzone';
import { DateRangeInputFormGroup } from '../../../processActivityFormGroupFields';

type ReportFormSectionProps = Readonly<{
    data: Record<string, string | null>;
    fieldKey: AssetCategory;
    title: string;
}>;

export function ReportFormSection(props: ReportFormSectionProps) {
    const { errors, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <FormSection title={props.title}>
            <DateRangeInputFormGroup
                data={props.data}
                errors={errors}
                fieldKey={props.fieldKey}
                label="Periode rapport"
                onChange={onChange}
            />

            <ProcessActivityAssetsDropzone
                assetCategory={props.fieldKey}
                label="Rapport"
            />
        </FormSection>
    );
}
